// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4eb06d3f] .icon-info{margin-top:-3px;margin-right:4px}", ""]);
// Exports
module.exports = exports;
